import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconFacebook = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      className={`${classes}`}
      styles={styles}
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
    >
      <title>Facebook</title>
      <Path
        color={color}
        d='M36,8.37c-15.35,0-27.8,12.45-27.8,27.8,0,13.88,10.17,25.38,23.46,27.47v-19.43h-7.06v-8.04h7.06v-6.13c0-6.97,4.15-10.82,10.5-10.82,3.04,0,6.23.54,6.23.54v6.84h-3.51c-3.45,0-4.53,2.15-4.53,4.35v5.21h7.71l-1.23,8.04h-6.47v19.43c13.29-2.08,23.46-13.59,23.46-27.46,0-15.35-12.45-27.8-27.8-27.8h0Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
